export default class AvaliacaoEstagioProbatorio {

    constructor(avaliado={}, avaliador={}, segundoAvaliador={}, competencia={}, notas=[]) {
        this.avaliado = avaliado;
        this.avaliador = avaliador;
        this.segundoAvaliador = segundoAvaliador;
        this.competencia = competencia;
        this.notas = notas;
    }
}



// WEBPACK FOOTER //
// ./src/domain/avaliacaoEstagioProbatorio/index.js